import { useEffect, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { useLocation, useNavigate } from 'react-router';
import { getMallList } from 'app/api/mall';
import {
  addPermission,
  deletePermission,
  getModulesList,
  getParentMalls,
  getPermissionList,
  getRoleList,
  saveParentMalls,
  updatePermission,
} from 'app/api/users';
import {
  permissionValidationRules,
  validate,
} from 'app/constants/validation-constants';
import Message from 'app/utils/Message';
import Toast from 'app/utils/Toast';
const useCreatePermission = () => {
  const [edit, setEdit] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const userId = location?.state?.id ? location?.state?.id : '';

  const [rolesList, setRolesList] = useState([]);
  const [moduleList, setModuleList] = useState([]);
  const [mallList, setMallList] = useState([]);
  const [parentMallOptions, setParentMallOptions] = useState([]);
  const [permissionList, setPermissionList] = useState([]);
  const [pageLoading, setPageLoading] = useState(false);
  const [permissionId, setPermissionId] = useState('');

  const [refresh, setRefresh] = useState(false);
  const [error, setErrors] = useState({});
  const [values, setValues] = useState({
    mallId: '',
    roleId: '',
    parentMalls: [],
  });

  useEffect(() => {
    getMallListforDropdown();
    getRoles();
    getModules();
    getPermissionModules(userId);
    getParentMallsForUser(userId);
  }, [refresh]);

  async function getParentMallsForUser(id) {
    if (!id) return;
    let response = await getParentMalls(id);
    if (response && response?.responseCode === 200) {
      // MultiSelectDropdown matches prefill values against option.value as
      // strings, so keep the assigned parent malls as string ids.
      const temp = (response?.data || []).map((mid) => String(mid));
      setValues((prev) => ({ ...prev, parentMalls: temp }));
    }
  }

  async function getMallListforDropdown() {
    setPageLoading(true);
    let response = await getMallList(1);
    setPageLoading(false);
    if (response && response?.responseCode === 200) {
      let temp = await response?.data?.malls?.map((item, index) => {
        return {
          ...item,
          value: item.id,
          label: item.name,
        };
      });
      setMallList(temp);
      // Options for the "Parent Mall" multi-select. MultiSelectDropdown uses
      // `name` as the display value and matches selections by string `value`.
      setParentMallOptions(
        (response?.data?.malls || []).map((item) => ({
          value: String(item.id),
          name: item.name,
          label: item.name,
        }))
      );
    } else {
      Toast.error(
        response?.data ? response?.data : Message?.Error?.COMMON_MESSAGE
      );
    }
  }
  async function getRoles() {
    setPageLoading(true);
    let response = await getRoleList();
    setPageLoading(false);
    if (response && response?.responseCode === 200) {
      let temp = await response?.data?.roles?.map((item, index) => {
        return {
          ...item,
          value: item.id,
          label: item.name,
          checked: false,
        };
      });
      setRolesList(temp);
    } else {
      Toast.error(
        response?.data?.message
          ? response?.data?.message
          : Message.Error.COMMON_MESSAGE
      );
    }
  }
  async function getModules() {
    setPageLoading(true);
    let response = await getModulesList();
    setPageLoading(false);
    if (response && response?.responseCode === 200) {
      let temp = await response?.data?.modules?.map((item, index) => {
        return {
          id: item.id,
          moduleId: item.id,
          permission: false,
          description: item.description,
          name: item.name,
        };
      });
      setModuleList(temp);
    } else {
      Toast.error(
        response?.data?.message
          ? response?.data?.message
          : Message.Error.COMMON_MESSAGE
      );
    }
  }
  async function getPermissionModules(id) {
    setPageLoading(true);
    let response = await getPermissionList(id);
    setPageLoading(false);
    if (response && response?.responseCode === 200) {
      setPermissionList(response?.data);
    } else {
      Toast.error(
        response?.data?.message
          ? response?.data?.message
          : Message.Error.COMMON_MESSAGE
      );
    }
  }
  async function callServiePublishOrUnpublishAPI(data) {
    setPageLoading(true);
    if (data && data?.id) {
      let responseObj = await deletePermission(data?.id);
      setPageLoading(false);
      if (responseObj?.responseCode === 200) {
        Toast.success('Menu Deleted Successfully');
      } else {
        Toast.error(
          responseObj?.response?.message
            ? responseObj?.response?.message
            : Message.Error.COMMON_MESSAGE
        );
      }
    } else {
      Toast.error('Failed to delete');
    }
  }
  async function handleDelete(data) {
    confirmAlert({
      title: '',
      message: `Are you sure you want to Delete`,
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            callServiePublishOrUnpublishAPI(data);
          },
        },
        {
          label: 'No',
        },
      ],
      overlayClassName: 'overlay-custom-class-name',
    });
  }
  function handleRolesSelection(e) {
    const { id, checked } = e.target;
    setErrors({
      ...error,
      roleId: '',
    });
    if (!checked) {
      const updatedMasterList = rolesList?.map((item) => ({
        ...item,
        checked: false,
      }));
      setRolesList(updatedMasterList);
      setValues((prevValues) => ({
        ...prevValues,
        roleId: '',
        name: '',
      }));
      return;
    }

    const updatedMasterList = rolesList.map((item) => ({
      ...item,
      checked: item.id.toString() === id ? true : false,
    }));
    const targetItem = rolesList.find((item) => item.id.toString() === id);
    const tempname = targetItem ? targetItem?.name : null;
    setValues((prevValues) => ({
      ...prevValues,
      roleId: id,
      name: tempname,
    }));
    setRolesList([...updatedMasterList]);
  }
  function handleModulesSelection(e) {
    const { id, checked } = e.target;

    const updatedMasterList = moduleList.map((item) => ({
      ...item,
      permission: item?.id.toString() === id ? checked : item.permission,
    }));

    setModuleList([...updatedMasterList]);
  }
  function handleParentMallChange(e) {
    const { value } = e.target;
    setValues((prev) => ({ ...prev, parentMalls: value }));
  }
  // Parent-mall visibility is a per-user setting, saved on its own — it does
  // NOT require a Mall/Role/module selection like the permission row does.
  async function handleSaveParentMalls() {
    if (!userId) {
      Toast.error('Please create/select the user before setting parent malls.');
      return;
    }
    setPageLoading(true);
    const response = await saveParentMalls(userId, values.parentMalls || []);
    setPageLoading(false);
    if (response?.responseCode === 200) {
      Toast.success('Parent malls saved successfully');
    } else {
      Toast.error(
        response?.response?.message
          ? response?.response?.message
          : Message.Error.COMMON_MESSAGE
      );
    }
  }
  async function callAddOrUpdateAPI() {
    setPageLoading(true);
    let response = {};
    let temp = moduleList?.map((item, index) => {
      return {
        moduleId: item.id,
        permission: item.permission,
      };
    });

    // parentMalls is saved separately (its own Save button), so keep it out of
    // the permission-row payload — the permission form stays mall/role-scoped.
    const { parentMalls, ...permissionValues } = values;
    let senddata = {
      ...permissionValues,
      userId: userId,
      permissions: temp,
    };
    if (edit) {
      response = await updatePermission(permissionId, { ...senddata });
    } else {
      response = await addPermission({ ...senddata });
    }
    setPageLoading(false);

    if (response?.responseCode === 200) {
      Toast.success(
        userId
          ? Message.Permission.UPDATED_SUCCESS
          : Message.Permission.CREATED_SUCCESS
      );
      setPermissionList([]);
      setModuleList([]);
      setPermissionList([]);
      setMallList([]);
      setValues({
        mallId: '',
        roleId: '',
        // Keep the parent-mall scope; the refresh re-fetches it from the server.
        parentMalls: values.parentMalls,
      });
      setRefresh(!refresh);
    } else {
      Toast.error(
        response?.response?.message
          ? response?.response?.message
          : Message.Error.COMMON_MESSAGE
      );
    }
  }

  function handleCreatePermission(e) {
    e.preventDefault();
    const validationErrors = validate(values, permissionValidationRules);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      callAddOrUpdateAPI();
    }
  }

  function handleChange(e) {
    if (e && e.target) {
      const { name, value } = e.target;
      const mallId = parseInt(value);

      const permissionitem = permissionList.find(
        (item) => item?.mallId === mallId
      );

      if (permissionitem) {
        setPermissionId(permissionitem?.permissionId);
        setEdit(true);
        const updatedRolesList = rolesList?.map((role) => ({
          ...role,
          checked: role.id === permissionitem?.roleId ? true : false,
        }));
        setRolesList(updatedRolesList);
        const updatedModuleList = moduleList?.map((moduleItem) => {
          const permissionStatus = permissionitem?.permissions?.find(
            (perm) => perm.moduleId === moduleItem.moduleId
          )?.permission;

          return {
            ...moduleItem,
            checked: !!permissionStatus,
            permission: !!permissionStatus,
          };
        });

        setModuleList(updatedModuleList);
        setValues({
          ...values,
          mallId: mallId,
          roleId: permissionitem.roleId,
        });
      } else {
        setEdit(false);
        setPermissionId('');
        setValues({
          ...values,
          mallId: mallId,
          roleId: '',
        });

        const resetRolesList = rolesList?.map((role) => ({
          ...role,
          checked: false,
        }));
        setRolesList(resetRolesList);

        const resetModuleList = moduleList?.map((module) => ({
          ...module,
          checked: false,
          permission: false,
        }));
        setModuleList(resetModuleList);
      }
      if (error[name]) {
        setErrors({
          ...error,
          [name]: '',
        });
      }
    }
  }

  return {
    pageLoading,
    navigate,
    handleChange,
    values,
    error,
    rolesList,
    moduleList,
    mallList,
    parentMallOptions,
    permissionList,
    handleDelete,
    handleRolesSelection,
    handleModulesSelection,
    handleParentMallChange,
    handleSaveParentMalls,
    handleCreatePermission,
  };
};

export default useCreatePermission;
